
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

var max = Math.max;
var min = Math.min;
var round = Math.round;

export { max, min, round };
//# sourceMappingURL=math.js.map
